(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-home-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('partner-product-shelf')) {
  customElements.define('partner-product-shelf', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const track = this.querySelector('.partner-shelf__track');
      const cards = [...this.querySelectorAll('.partner-shelf__card')];
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = !(filter === 'all' || (filter === 'treat' ? card.dataset.treat === 'true' : card.dataset.pets.includes(filter))); });
        this.querySelector('[data-result-count]').textContent = cards.filter(card => !card.hidden).length + ' recipes';
        track.scrollTo({left: 0, behavior: 'instant'});
      }));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-home-solutions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('partner-solutions')) {
  customElements.define('partner-solutions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const buttons = [...this.querySelectorAll('[data-pet]')];
      const cards = [...this.querySelectorAll('[data-for-pet]')];
      const select = pet => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pet === pet)));
        cards.forEach(card => { card.hidden = card.dataset.forPet !== pet; });
      };
      this.querySelector('.partner-solutions__filters').hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.pet)));
      select('dog');
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-for-pet]');
        if (card) select(card.dataset.forPet);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-home"] && !Shopify.designMode) return;
  try {
    
  function syncPartnerHomePurchase(root) {
    if (!root) return;
    const price = root.querySelector('[data-partner-home-price]');
    const plan = root.querySelector('[data-partner-home-plan]');
    const button = root.querySelector('[data-home-purchase-button]');
    const mode = root.querySelector('[data-home-purchase-mode]:checked')?.value || 'once';
    const subscribe = mode === 'subscription';
    if (!button) return;
    if (plan) { plan.disabled = !subscribe; plan.required = subscribe; }
    const schedule = root.querySelector('[data-home-schedule]');
    if (schedule) schedule.hidden = !subscribe;
    const recurring = root.querySelector('[data-home-recurring-note]');
    const once = root.querySelector('[data-home-once-note]');
    if (recurring) recurring.hidden = !subscribe;
    if (once) once.hidden = subscribe;
    const label = button.querySelector('[data-home-purchase-button-label]');
    if (label) label.textContent = subscribe ? button.dataset.subscribeLabel : button.dataset.onceLabel;
    if (price) price.textContent = subscribe ? plan.selectedOptions[0].dataset.price : button.dataset.oncePrice;
  }
  function syncPartnerHomePurchases() {
    document.querySelectorAll('.partner-home').forEach(syncPartnerHomePurchase);
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-partner-home-plan], [data-home-purchase-mode]')) syncPartnerHomePurchase(event.target.closest('.partner-home'));
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('.ph-product-form')) syncPartnerHomePurchase(event.target.closest('.partner-home'));
  });
  function refreshPartnerHomePurchases() {
    syncPartnerHomePurchases();
    window.setTimeout(syncPartnerHomePurchases, 0);
  }
  window.addEventListener('pageshow', refreshPartnerHomePurchases);
  window.addEventListener('popstate', refreshPartnerHomePurchases);
  document.addEventListener('shopify:section:load', refreshPartnerHomePurchases);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshPartnerHomePurchases, { once: true });
  else refreshPartnerHomePurchases();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partner-product')) {
    customElements.define('partner-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('pageshow', this.refreshPurchaseState);
          window.addEventListener('popstate', this.refreshPurchaseState);
          this.refreshPurchaseState();
          return;
        }
        this.initialized = true;
        this.plan = this.querySelector('[data-partner-plan]');
        this.quantity = this.querySelector('[data-partner-quantity]');
        this.weight = this.querySelector('[data-pet-weight]');
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.refreshPurchaseState = () => {
          this.update();
          window.clearTimeout(this.restoreTimer);
          this.restoreTimer = window.setTimeout(() => this.update(), 0);
        };
        window.addEventListener('pageshow', this.refreshPurchaseState);
        window.addEventListener('popstate', this.refreshPurchaseState);
        this.querySelector('form')?.addEventListener('submit', this.refreshPurchaseState);
        this.querySelectorAll('[data-image-url]').forEach((thumbnail) => {
          thumbnail.addEventListener('click', (event) => {
            event.preventDefault();
            const image = this.querySelector('.partner-pdp__image');
            if (!image) return;
            image.srcset = thumbnail.dataset.imageSrcset;
            image.src = thumbnail.dataset.imageUrl;
            image.alt = thumbnail.dataset.imageAlt;
            this.querySelectorAll('[data-image-url]').forEach((item) => { item.classList.remove('is-selected'); item.removeAttribute('aria-current'); });
            thumbnail.classList.add('is-selected');
            thumbnail.setAttribute('aria-current', 'true');
          });
        });
        this.querySelectorAll('[data-purchase-option]').forEach((radio) => radio.addEventListener('change', () => this.update()));
        this.plan?.addEventListener('change', () => this.update());
        this.quantity?.addEventListener('input', () => this.update());
        this.weight?.addEventListener('change', () => this.update());
        this.refreshPurchaseState();
      }
      disconnectedCallback() {
        window.removeEventListener('pageshow', this.refreshPurchaseState);
        window.removeEventListener('popstate', this.refreshPurchaseState);
        window.clearTimeout(this.restoreTimer);
      }
      update() {
        const selectedMode = this.querySelector('[data-purchase-option]:checked')?.value;
        const isSubscription = Boolean(this.plan && selectedMode !== 'one-time');
        if (this.plan) {
          this.plan.disabled = !isSubscription;
          this.plan.required = isSubscription;
        }
        this.querySelectorAll('[data-purchase-card]').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('input')?.checked)));
        const planField = this.querySelector('[data-plan-field]');
        if (planField) planField.hidden = !isSubscription;
        this.querySelector('[data-purchase-fields]')?.classList.toggle('partner-pdp__field-grid--one-time', !isSubscription);
        const subscriptionDisclosure = this.querySelector('[data-subscription-disclosure]');
        const oneTimeDisclosure = this.querySelector('[data-one-time-disclosure]');
        if (subscriptionDisclosure) subscriptionDisclosure.hidden = !isSubscription;
        if (oneTimeDisclosure) oneTimeDisclosure.hidden = isSubscription;
        const option = isSubscription ? this.plan?.selectedOptions[0] : null;
        const price = Number(option?.dataset.price || this.dataset.oneTimePrice || this.dataset.price);
        const grams = Number(this.dataset.grams);
        const quantity = Math.max(1, Number(this.quantity?.value) || 1);
        this.querySelector('[data-partner-price]').textContent = option?.dataset.priceFormatted || this.dataset.oneTimeFormatted;
        const planDetail = this.querySelector('[data-plan-detail]');
        if (planDetail) { planDetail.textContent = option?.dataset.planDescription || ''; planDetail.hidden = !isSubscription; }
        const checkoutPrice = this.querySelector('[data-checkout-price]');
        if (checkoutPrice) checkoutPrice.textContent = this.money.format(Number(option?.dataset.checkout || price) * quantity / 100);
        if (!this.weight || !Number.isFinite(price) || !(grams > 0)) return;
        const [low, high] = this.weight.value.split(',').map(Number);
        if (this.weight.selectedOptions[0]?.dataset.upperBound === 'true') {
          this.querySelector('[data-daily-cost]').textContent = this.dataset.upperCostLabel.replace('[amount]', this.money.format(price * high / grams / 100));
          this.querySelector('[data-bag-days]').textContent = this.dataset.upperDaysLabel.replace('[days]', (grams / high).toFixed(1));
          this.querySelector('[data-bag-recommendation]').hidden = true;
          return;
        }
        this.querySelector('[data-daily-cost]').textContent = `${this.money.format(price * low / grams / 100)}–${this.money.format(price * high / grams / 100)}`;
        this.querySelector('[data-bag-days]').textContent = this.dataset.daysLabel.replace('[low]', (grams / high).toFixed(1)).replace('[high]', (grams / low).toFixed(1));
        const recommendation = this.querySelector('[data-bag-recommendation]');
        const weeks = option?.textContent.match(/\b(2|4|6|8)\s*(?:weeks?|wks?)\b/i);
        recommendation.hidden = !weeks;
        if (weeks) {
          const days = Number(weeks[1]) * 7;
          const lowBags = Math.ceil(days * low / grams);
          const highBags = Math.ceil(days * high / grams);
          const bagLabel = lowBags === highBags ? this.dataset.bagsLabel.replace(/\[low\]\s*[–—-]\s*\[high\]/, '[low]') : this.dataset.bagsLabel;
          recommendation.textContent = bagLabel.replace('[low]', lowBags).replace('[high]', highBags).replace('[weeks]', weeks[1]);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-treat-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partner-product')) {
    customElements.define('partner-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('pageshow', this.refreshPurchaseState);
          window.addEventListener('popstate', this.refreshPurchaseState);
          this.refreshPurchaseState();
          return;
        }
        this.initialized = true;
        this.plan = this.querySelector('[data-partner-plan]');
        this.quantity = this.querySelector('[data-partner-quantity]');
        this.weight = this.querySelector('[data-pet-weight]');
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.refreshPurchaseState = () => {
          this.update();
          window.clearTimeout(this.restoreTimer);
          this.restoreTimer = window.setTimeout(() => this.update(), 0);
        };
        window.addEventListener('pageshow', this.refreshPurchaseState);
        window.addEventListener('popstate', this.refreshPurchaseState);
        this.querySelector('form')?.addEventListener('submit', this.refreshPurchaseState);
        this.querySelectorAll('[data-image-url]').forEach((thumbnail) => {
          thumbnail.addEventListener('click', (event) => {
            event.preventDefault();
            const image = this.querySelector('.partner-pdp__image');
            if (!image) return;
            image.srcset = thumbnail.dataset.imageSrcset;
            image.src = thumbnail.dataset.imageUrl;
            image.alt = thumbnail.dataset.imageAlt;
            this.querySelectorAll('[data-image-url]').forEach((item) => { item.classList.remove('is-selected'); item.removeAttribute('aria-current'); });
            thumbnail.classList.add('is-selected');
            thumbnail.setAttribute('aria-current', 'true');
          });
        });
        this.querySelectorAll('[data-purchase-option]').forEach((radio) => radio.addEventListener('change', () => this.update()));
        this.plan?.addEventListener('change', () => this.update());
        this.quantity?.addEventListener('input', () => this.update());
        this.weight?.addEventListener('change', () => this.update());
        this.refreshPurchaseState();
      }
      disconnectedCallback() {
        window.removeEventListener('pageshow', this.refreshPurchaseState);
        window.removeEventListener('popstate', this.refreshPurchaseState);
        window.clearTimeout(this.restoreTimer);
      }
      update() {
        const selectedMode = this.querySelector('[data-purchase-option]:checked')?.value;
        const isSubscription = Boolean(this.plan && selectedMode !== 'one-time');
        if (this.plan) {
          this.plan.disabled = !isSubscription;
          this.plan.required = isSubscription;
        }
        this.querySelectorAll('[data-purchase-card]').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('input')?.checked)));
        const planField = this.querySelector('[data-plan-field]');
        if (planField) planField.hidden = !isSubscription;
        this.querySelector('[data-purchase-fields]')?.classList.toggle('partner-pdp__field-grid--one-time', !isSubscription);
        const subscriptionDisclosure = this.querySelector('[data-subscription-disclosure]');
        const oneTimeDisclosure = this.querySelector('[data-one-time-disclosure]');
        if (subscriptionDisclosure) subscriptionDisclosure.hidden = !isSubscription;
        if (oneTimeDisclosure) oneTimeDisclosure.hidden = isSubscription;
        const option = isSubscription ? this.plan?.selectedOptions[0] : null;
        const price = Number(option?.dataset.price || this.dataset.oneTimePrice || this.dataset.price);
        const grams = Number(this.dataset.grams);
        const quantity = Math.max(1, Number(this.quantity?.value) || 1);
        this.querySelector('[data-partner-price]').textContent = option?.dataset.priceFormatted || this.dataset.oneTimeFormatted;
        const planDetail = this.querySelector('[data-plan-detail]');
        if (planDetail) { planDetail.textContent = option?.dataset.planDescription || ''; planDetail.hidden = !isSubscription; }
        const checkoutPrice = this.querySelector('[data-checkout-price]');
        if (checkoutPrice) checkoutPrice.textContent = this.money.format(Number(option?.dataset.checkout || price) * quantity / 100);
        if (!this.weight || !Number.isFinite(price) || !(grams > 0)) return;
        const [low, high] = this.weight.value.split(',').map(Number);
        if (this.weight.selectedOptions[0]?.dataset.upperBound === 'true') {
          this.querySelector('[data-daily-cost]').textContent = this.dataset.upperCostLabel.replace('[amount]', this.money.format(price * high / grams / 100));
          this.querySelector('[data-bag-days]').textContent = this.dataset.upperDaysLabel.replace('[days]', (grams / high).toFixed(1));
          this.querySelector('[data-bag-recommendation]').hidden = true;
          return;
        }
        this.querySelector('[data-daily-cost]').textContent = `${this.money.format(price * low / grams / 100)}–${this.money.format(price * high / grams / 100)}`;
        this.querySelector('[data-bag-days]').textContent = this.dataset.daysLabel.replace('[low]', (grams / high).toFixed(1)).replace('[high]', (grams / low).toFixed(1));
        const recommendation = this.querySelector('[data-bag-recommendation]');
        const weeks = option?.textContent.match(/\b(2|4|6|8)\s*(?:weeks?|wks?)\b/i);
        recommendation.hidden = !weeks;
        if (weeks) {
          const days = Number(weeks[1]) * 7;
          const lowBags = Math.ceil(days * low / grams);
          const highBags = Math.ceil(days * high / grams);
          const bagLabel = lowBags === highBags ? this.dataset.bagsLabel.replace(/\[low\]\s*[–—-]\s*\[high\]/, '[low]') : this.dataset.bagsLabel;
          recommendation.textContent = bagLabel.replace('[low]', lowBags).replace('[high]', highBags).replace('[weeks]', weeks[1]);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partner-ugc')) {
    class PartnerUgc extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.dialog = this.querySelector('dialog');
        this.track = this.querySelector('.partner-ugc__track');
        this.prev = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        this.cards = [...this.querySelectorAll('[data-ugc-card]')];
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.fine = matchMedia('(hover: hover) and (pointer: fine)');
        this.cards.forEach(card => {
          const cover = card.querySelector('[data-ugc-open]');
          card.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !this.fine.matches || this.motion.matches || navigator.connection?.saveData || this.dialog.open) return;
            this.clearIntent();
            this.intent = setTimeout(() => this.startPreview(card), 180);
          }, { signal });
          card.addEventListener('pointerleave', () => { this.clearIntent(); this.stopPreview(card); }, { signal });
          cover.addEventListener('click', () => this.openClip(card, cover), { signal });
        });
        this.querySelector('[data-ugc-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('close', () => this.closeClip(), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.clearIntent(); this.stopPreview(); this.modalVideo?.pause(); }
        }, { signal });
        this.prev.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.visibleObserver = new IntersectionObserver(entries => {
          for (const entry of entries) if (!entry.isIntersecting) this.stopPreview(entry.target);
        });
        this.updateArrows();
      }
      clearIntent() { clearTimeout(this.intent); this.intent = null; }
      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.querySelector('.partner-ugc__arrows').hidden = max < 4;
        this.prev.disabled = this.track.scrollLeft < 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
        const progress = this.querySelector('[data-ugc-progress]');
        progress.parentElement.hidden = max < 4;
        const fraction = this.track.clientWidth / this.track.scrollWidth;
        progress.style.setProperty('--ugc-progress-width', `${fraction * 100}%`);
        progress.style.setProperty('--ugc-progress-offset', `${this.track.scrollLeft / this.track.clientWidth * 100}%`);
      }
      move(direction) {
        this.clearIntent(); this.stopPreview();
        this.track.scrollBy({ left: direction * this.track.clientWidth * .8, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      startPreview(card) {
        if (this.dialog.open || document.hidden) return;
        PartnerUgc.active?.stopPreview();
        this.stopPreview();
        const video = document.createElement('video');
        video.className = 'partner-ugc__preview';
        video.muted = true; video.defaultMuted = true; video.loop = true; video.playsInline = true; video.preload = 'none';
        video.setAttribute('aria-hidden', 'true'); video.tabIndex = -1;
        this.preview = { card, video }; PartnerUgc.active = this;
        video.addEventListener('playing', () => { if (this.preview?.video === video) card.classList.add('is-playing'); });
        video.addEventListener('error', () => this.stopPreview(card), { once: true });
        card.querySelector('[data-ugc-open]').append(video);
        this.visibleObserver.observe(card);
        video.src = card.dataset.preview;
        video.play().catch(() => { if (this.preview?.video === video) this.stopPreview(card); });
      }
      release(video) { if (!video) return; video.pause(); video.removeAttribute('src'); video.load(); video.remove(); }
      stopPreview(card) {
        if (!this.preview || (card && card !== this.preview.card)) return;
        const current = this.preview; this.preview = null;
        current.card.classList.remove('is-playing');
        this.visibleObserver?.unobserve(current.card);
        this.release(current.video);
        if (PartnerUgc.active === this) PartnerUgc.active = null;
      }
      openClip(card, trigger) {
        this.clearIntent(); PartnerUgc.active?.stopPreview(); this.stopPreview();
        this.trigger = trigger;
        const content = this.querySelector('[data-ugc-content]');
        content.replaceChildren(card.querySelector('template').content.cloneNode(true));
        this.querySelector('[data-ugc-error]').hidden = true;
        const video = document.createElement('video');
        video.controls = true; video.playsInline = true; video.preload = 'none';
        video.poster = card.querySelector('img').currentSrc || card.querySelector('img').src;
        video.setAttribute('aria-label', trigger.getAttribute('aria-label'));
        video.addEventListener('error', () => { this.querySelector('[data-ugc-error]').hidden = false; }, { once: true });
        this.querySelector('[data-ugc-media]').replaceChildren(video);
        this.modalVideo = video;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-ugc-close]').focus({ preventScroll: true });
        video.src = card.dataset.video;
        video.play().catch(() => {});
      }
      closeClip() {
        this.release(this.modalVideo); this.modalVideo = null;
        this.querySelector('[data-ugc-content]').replaceChildren();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.trigger?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.clearIntent(); this.stopPreview();
        if (this.dialog?.open) { this.dialog.close(); this.closeClip(); }
        this.abort?.abort(); this.resizeObserver?.disconnect(); this.visibleObserver?.disconnect();
        this.bound = false;
      }
    }
    customElements.define('partner-ugc', PartnerUgc);
  }

  } catch(e) { console.error(e); }
})();
})();
